export default "assets/images/icons/clock-404eaa30.svg";